<template>
  <ModalBase :show-modal="showModal" @close-modal="close" class="brand-modal">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
          {{ (isEdit) ? $gettext('EDIT'): $gettext('ADD') }}
        </template>
        <template v-slot:title>
          {{ brandName }}
        </template>
        <template v-slot:buttons>
          <div v-if="isEdit" class="modal-action-bar">
            <GekkoButton
              :text="$gettext('Delete')"
              icon="fa-solid fa-trash-can"
              class="text-danger"
              v-gk-confirm="{
                title: $gettext('Delete brand?'),
                message: $gettext('Are you sure you want to delete this brand?'),
                options: {
                    variant: 'danger',
                    confirmText: $gettext('Delete')
                },
                callback: deleteBrand
              }"
            />
          </div>
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <BrandCreateEdit @created="brandCreated" @edited="brandEdited" />
    </template>
    <template v-slot:premiumtip>
      <GekkoButton
          icon="fa-solid fa-circle-question"
          variant="link"
          size="lg"
          class="close-btn text-unassigned"
          style="right:1rem;"
          id="tt-premium-tip"
      />
      <b-tooltip :custom-class="'tooltip-padded'" target="tt-premium-tip" placement="bottom" triggers="hover">
        <div class="tooltip-title">
          {{ $gettext('Premium Tip') }}
        </div>
        <div class="tooltip-text">
          {{ premiumTipText }}
        </div>
      </b-tooltip>
    </template>
  </ModalBase>
</template>
<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";
import BrandCreateEdit from "@/components/brands/BrandCreateEdit"
import BrandService from "@/store/services/brand.service";
import {mapGetters} from "vuex";
export default {
  name: "BrandModal",
  props: {
    selectedBrand: {
      type: Number,
      default: null
    },
  },
  components: { ModalBase, GekkoButton, TitleBar, BrandCreateEdit },
  data() {
    return {
      showModal: true,
      state: 'create',
      brandObject: {},
      premiumTipText: this.$gettext("You can create multiple brands"),
    }
  },
  mounted(){
    document.body.classList.add('modal-on')
  },
  created() {
    if(this.selectedBrandId === 0){
      this.state = "create";
    }else{
      this.state = "edit";
    }
  },
  destroyed() {
  },
  methods: {
    close () {
      document.body.classList.remove('modal-on')
      this.$emit('close')
      this.showModal = false
    },
    brandCreated(value) {
      this.showModal = false
      this.$emit('created', value)
    },
    brandEdited(value) {
      this.showModal = false
      this.$emit('edited')
    },
    deleteBrand() {
      BrandService.destroy(this.selectedBrandId).then(()=>{
        this.showModal = false
        this.$emit('deleted')
      })
    },
  },
  computed: {
    ...mapGetters({
      availableBrands: 'brands/getAvailableBrands',
      selectedBrandName: 'brands/getSelectedBrandName',
      selectedBrandId: 'brands/getSelectedBrandId',
    }),
    isEdit() {
      return this.state === 'edit';
    },
    brandName(){
      if(this.isEdit){
        return this.selectedBrandName;
      }
      if(this.selectedBrandName !== ""){
        return this.selectedBrandName;
      }
      return this.$gettext("New Brand");
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
